// extracted by mini-css-extract-plugin
module.exports = {"columnTableHead":"SlaDataTable_columnTableHead__1lbFL"};